// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBtHnnGptwVcOSeEMcfF_ybhevb0i06X7Q",
  authDomain: "wildbach-hinwil.firebaseapp.com",
  projectId: "wildbach-hinwil",
  storageBucket: "wildbach-hinwil.firebasestorage.app",
  messagingSenderId: "776362084316",
  appId: "1:776362084316:web:b19929e1c10cfd944e7119",
  measurementId: "G-QP1JDZKSSY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app; 